import React from 'react';
import { DiagnosticsStatusByClassReportQuery } from '../../../graphQLOperations/__generated__/DiagnosticsStatusByClassReportQuery.graphql';
import { PreloadedQuery } from 'react-relay/relay-hooks/EntryPointTypes';
import { TeacherDiagnosticDashboard } from './TeacherDiagnosticDashboard';
import { DiagnosticsStatusByTargetGroupReportQuery } from '../../../graphQLOperations/__generated__/DiagnosticsStatusByTargetGroupReportQuery.graphql';

interface Props {
  queryDiagnosticStatusByClassReportRef: PreloadedQuery<DiagnosticsStatusByClassReportQuery, Record<string, unknown>>;
  queryDiagnosticStatusByTargetGoupReportRef: PreloadedQuery<
    DiagnosticsStatusByTargetGroupReportQuery,
    Record<string, unknown>
  >;
  isSiteAdmin: boolean;
  isFilteredByRoadmap: boolean;
  activeClassId: string | null;
  onWidgetHidden: (classId: string) => void;
}

export const TeacherDiagnosticDashboardWrapper: React.FC<Props> = ({
  queryDiagnosticStatusByClassReportRef,
  queryDiagnosticStatusByTargetGoupReportRef,
  isSiteAdmin,
  isFilteredByRoadmap,
  activeClassId,
  onWidgetHidden,
}) => {
  // The dashboard reads exactly one report depending on this predicate, so bail
  // unless *that* ref is ready — otherwise usePreloadedQuery gets a null queryRef
  // and throws (e.g. a siteAdmin on the CLASSES filter with no class loaded yet).
  const activeReportRef =
    isSiteAdmin && isFilteredByRoadmap
      ? queryDiagnosticStatusByTargetGoupReportRef
      : queryDiagnosticStatusByClassReportRef;

  if (!activeReportRef) {
    return null;
  }

  return (
    <TeacherDiagnosticDashboard
      queryDiagnosticStatusByClassReportRef={queryDiagnosticStatusByClassReportRef}
      queryDiagnosticStatusByTargetGoupReportRef={queryDiagnosticStatusByTargetGoupReportRef}
      isSiteAdmin={isSiteAdmin}
      isFilteredByRoadmap={isFilteredByRoadmap}
      activeClassId={activeClassId}
      onWidgetHidden={onWidgetHidden}
    />
  );
};

export default TeacherDiagnosticDashboardWrapper;
